// extracted by mini-css-extract-plugin
module.exports = {"AppButton":"vMUYQ"};